import React, { memo } from 'react';
import '../../../Common/Filters/Filters.css';
import useLocations from './hooks/useLocations';
import MultipleSelect from '../../../Common/Filters/MultipleSelect';
import { useFiltersContext } from '../../../Common/Filters/hooks/useFiltersContext';

const Filters = ({ className = '' }) => {
    const { filters, onFilterChange } = useFiltersContext();
    const { data } = useLocations(filters.cidade?.value);

    const locations = data || [];

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Centro de Assistência"
                options={[
                    { value: '', label: 'Todos' },
                    ...locations.map((location) => ({
                        value: location.cod_centro_assist_fam,
                        label: location.nom_centro_assist_fam
                    }))
                ]}
                onChange={onFilterChange}
                name="unidade"
                className="select-unidade-dashboards"
                defaultValue={filters.unidade}
            />
        </div>
    );
};

export default memo(Filters);
